import { Dayjs } from 'dayjs'

export interface Receivement {
  id: number,
  listNumberArId: string
  startedAt?: Dayjs,
  status: string,
  supplierName: string,
  fulfillmentCenterId?: number,
  fulfillmentCenterName: string,
}

export interface ReceivementOverviewListState {
  receivementStatusList: ReceivementStatusType[],
  totalPages: number,
  totalItems?: number,
  page: number,
  pageSize: number,
  receivements: Receivement[],
  startDate?: Dayjs,
  endDate?: Dayjs,
  idFc?: string,
  idSupplier?: string,
  idAr?: string,
  idStatus?: string,
  invoiceNumber?: string,
  invoiceKey?: string,
  fcActive: boolean,
  suppliers?: FilterSupplier[],
}

export interface GetReceivementOverviewListPayload {
  badge: string,
  page: number,
  pageSize: number,
  startDate: Dayjs,
  endDate: Dayjs,
  idFc?: string,
  idSupplier?: string,
  idAr?: string,
  idStatus?: number,
  invoiceNumber?: string,
  invoiceKey?: string,
  fcActive: boolean,
}

export interface GetReceivementOverviewListSagaPayload {
  badge: string,
  page?: number,
  pageSize?: number,
}

export enum GenericApiErrors {
  Failed,
}

export interface GetReceivementOverviewListResponse {
  links: {
    next: string,
    prev: string,
    self: string,
  },
  meta: {
    page: number,
    perPage: number,
    totalItems: number,
    totalPages: number,
  }
  data: ReceivementResponse[],
}

export interface ReceivementResponse {
  idRecebimento: number,
  arIds: number[],
  dtInicioRecebimento: Date,
  status: string,
  fornecedor: {
    nmFornecedor: string,
  },
  fulfillmentCenter: {
    id: number,
    name: string,
  }
}

export interface GetReceivementStatusListPayload {
  badge: string,
}

export type GetReceivementStatusListResponse = ReceivementStatusType[]

export interface ReceivementStatusType {
  id: number,
  description: string,
}

export interface SetReceivementOverviewListPayload {
  receivements: ReceivementOverviewListState['receivements']
  totalPages: ReceivementOverviewListState['totalPages'],
  totalItems: ReceivementOverviewListState['totalItems']
  page: ReceivementOverviewListState['page'],
  pageSize: ReceivementOverviewListState['pageSize'],
}

export interface SetDateIntervalPayload {
  startDate?: Dayjs,
  endDate?: Dayjs,
}

export interface UpdateOverviewFilterFieldPayload {
  key: keyof ReceivementOverviewListState;
  value: ReceivementOverviewListState[keyof ReceivementOverviewListState];
}

export interface FilterSupplier {
  id: number
  name: string
}
